import { Link } from "react-router-dom";

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="w-full bg-stone-900 text-white">
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <img
              src="https://static.readdy.ai/image/44752aaa2b8c60b6ac39ccbed2793a85/f0377fb5ec1076e4cb9e676fd4f0df74.jpeg"
              alt="Coliving HIDA TAKAYAMA"
              className="w-9 h-9 rounded-full object-cover"
            />
            <span
              className="text-base tracking-widest font-light"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              COLIVING HIDA TAKAYAMA
            </span>
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-300 hover:text-orange-400 transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
            Back to Home
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          {/* English Version */}
          <div className="mb-20">
            <h2 className="text-3xl font-semibold text-gray-900 mb-8" style={{ fontFamily: 'Noto Serif JP' }}>
              Legal Notice (Specified Commercial Transaction Act)
            </h2>
            
            <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <table className="w-full text-sm">
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top w-1/3">Business Operator</td>
                    <td className="py-4 text-gray-700">NPO MOSHI MOSHI</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Representative</td>
                    <td className="py-4 text-gray-700">Kazunobu Shimomoto</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Address</td>
                    <td className="py-4 text-gray-700">
                      3F Paulownia Building, 3-58-11 Honmachi, Takayama City, Gifu 506-0011, Japan
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Phone Number</td>
                    <td className="py-4 text-gray-700">090-4793-1612 (Business hours: Weekdays 10:00–17:00)</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Email</td>
                    <td className="py-4 text-gray-700">
                      <a href="mailto:info@moshimoshi.info" className="text-orange-500 hover:underline cursor-pointer">
                        info@moshimoshi.info
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Price</td>
                    <td className="py-4 text-gray-700">
                      As stated on each plan/room introduction page<br />
                      (Tax-exempt as residential rental)
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Additional Fees</td>
                    <td className="py-4 text-gray-700">
                      None (excluding communication fees for browsing the site, inquiries, etc.)
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Payment Method</td>
                    <td className="py-4 text-gray-700">Credit Card (Stripe)</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Payment Timing</td>
                    <td className="py-4 text-gray-700">
                      <strong>[Initial Payment]</strong> To be completed by the specified date after contract signing.<br /><br />
                      <strong>[Recurring Payment]</strong> For extensions, payment for the following month must be completed by the 25th of the current month.
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Service Provision</td>
                    <td className="py-4 text-gray-700">
                      Service provision begins on the scheduled move-in date after contract signing and payment completion.
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">Cancellation &amp; Refund</td>
                    <td className="py-4 text-gray-700">
                      <strong>[Before Move-in]</strong> Refunds will be processed according to our cancellation policy. Please refer to the contract for details.<br /><br />
                      <strong>[After Move-in]</strong> Due to the nature of the service, no refunds will be provided for early termination after move-in. To terminate the contract, at least 10 days' prior notice is required.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Japanese Version */}
          <div>
            <h2 className="text-3xl font-semibold text-gray-900 mb-8" style={{ fontFamily: 'Noto Serif JP' }}>
              特定商取引法に基づく表記
            </h2>
            
            <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
              <table className="w-full text-sm">
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top w-1/3">事業者名</td>
                    <td className="py-4 text-gray-700">特定非営利活動法人ＭＯＳＨＩＭＯＳＨＩ</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">代表者</td>
                    <td className="py-4 text-gray-700">下本 一伸</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">所在地</td>
                    <td className="py-4 text-gray-700">
                      〒506-0011 岐阜県高山市本町3丁目58-11 ポロニアビル 3F
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">電話番号</td>
                    <td className="py-4 text-gray-700">090-4793-1612（受付時間：平日10:00〜17:00）</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">メールアドレス</td>
                    <td className="py-4 text-gray-700">
                      <a href="mailto:info@moshimoshi.info" className="text-orange-500 hover:underline cursor-pointer">
                        info@moshimoshi.info
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">販売価格</td>
                    <td className="py-4 text-gray-700">
                      各プラン・お部屋の紹介ページに記載された金額（居住用賃貸のため非課税）
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">商品代金以外に必要な費用</td>
                    <td className="py-4 text-gray-700">
                      なし（サイト閲覧、お問い合わせ等の通信料は除く）
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">支払方法</td>
                    <td className="py-4 text-gray-700">クレジットカード決済（Stripe）</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">支払時期</td>
                    <td className="py-4 text-gray-700">
                      <strong>入居前：</strong>契約締結後、指定の期日までにお支払いください。<br /><br />
                      <strong>継続利用：</strong>翌月分を前月25日までにお支払いください。
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">サービス提供時期</td>
                    <td className="py-4 text-gray-700">
                      契約締結および決済完了後、予定された入居日より提供を開始します。
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-6 font-semibold text-gray-900 align-top">キャンセル・返金</td>
                    <td className="py-4 text-gray-700">
                      <strong>【入居前】</strong> キャンセルポリシーに基づき返金を行います。詳細は契約書をご確認ください。<br /><br />
                      <strong>【入居後】</strong> サービスの性質上、入居後の期間短縮等による返金は原則として行いません。中途解約を希望される場合は、退去希望日の10日前までに通知が必要です。
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <div className="mt-12 text-center">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-orange-500 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
          Back to Home
        </Link>
      </div>

      {/* Footer */}
      <footer className="bg-stone-100 border-t border-gray-200">
        <div className="max-w-5xl mx-auto px-6 py-8 text-center text-xs text-gray-400">
          &copy; {new Date().getFullYear()} NPO MOSHIMOSHI. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
